import type { FC } from 'react';
import { useStore } from 'zustand';

import { ModalEnquiryList } from 'Features/SellerCommunications/components/ModalEnquiryList';
import {
	EnquiriesSearchStore,
	EnquiriesSelectStore,
	EnquiriesStore,
	enquirySelectionService,
} from 'Features/SellerCommunications/services';

export const EnquirySelectionListItems: FC = () => {
	const enquiries = useStore(EnquiriesStore, (state) => state.enquiries);
	const interactedSaleIds = useStore(EnquiriesSelectStore, (state) => state.interactedSaleIds);
	const filteredSaleIds = useStore(EnquiriesSearchStore, (state) => state.filteredSaleIds);

	return (
		<ModalEnquiryList
			enquiries={enquiries}
			filteredSaleIds={filteredSaleIds}
			interactedSaleIds={interactedSaleIds}
			onToggle={enquirySelectionService.onItemToggle}
		/>
	);
};
